import { render, staticRenderFns } from "./chart-module.vue?vue&type=template&id=488f98f4&scoped=true&"
import script from "./chart-module.vue?vue&type=script&lang=ts&"
export * from "./chart-module.vue?vue&type=script&lang=ts&"
import style0 from "./chart-module.vue?vue&type=style&index=0&id=488f98f4&lang=stylus&scoped=true&"
import style1 from "./chart-module.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488f98f4",
  null
  
)

export default component.exports